module.exports = __webpack_public_path__ + "media/product/cta-06-4eab984a.jpg";